(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/hooks/use-video-format.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/hooks/use-video-format.js');

'use strict';

const {
  useMemo
} = React;
const detectVideoFormat = () => {
  const video = document.createElement('video');
  const isSafari = svs.core.detect.browser.safari();
  const isIOS = svs.core.detect.os.iOS();
  const webm = video.canPlayType('video/webm; codecs="vp9"');
  if (!isSafari && !isIOS && (webm === 'probably' || webm === 'maybe')) {
    return {
      format: 'webm',
      mime: 'video/webm',
      codecs: 'vp9'
    };
  }
  const mov = video.canPlayType('video/quicktime; codecs="hvc1"');
  if (mov === 'probably' || mov === 'maybe') {
    return {
      format: 'video/quicktime',
      mime: 'video/quicktime',
      codecs: 'hvc1'
    };
  }
  const hevc = video.canPlayType('video/mp4; codecs="hvc1.1.6.L120.90"');
  if (hevc === 'probably' || hevc === 'maybe') {
    return {
      format: 'video/mp4',
      mime: 'video/mp4',
      codecs: 'hvc1.1.6.L120.90'
    };
  }
  return {
    format: null,
    mime: null,
    codecs: null
  };
};
const useVideoFormat = () => useMemo(detectVideoFormat, []);
setGlobal('svs.lotto.react.hooks', {
  useVideoFormat
});

 })(window);